import { useCallback, useState } from 'react';
import { useResizeObserver } from '../useResizeObserver/useResizeObserver.mjs';

function getScrollSize(element) {
  return {
    width: element.scrollWidth,
    height: element.scrollHeight
  };
}

// Returns a given element scrollHeight and scrollWidth
function useScrollSize(element) {
  const handleResize = useCallback(node => {
    if (node) {
      setScrollSize(currentSize => {
        const newSize = getScrollSize(node);
        if (!isEqual(newSize, currentSize)) {
          return newSize;
        }
        return currentSize;
      });
    }
  }, []);
  const [scrollSize, setScrollSize] = useState();
  useResizeObserver(element, handleResize, {
    observeChildren: true
  });
  return scrollSize;
}
function isEqual(size1, size2) {
  return (size1 === null || size1 === void 0 ? void 0 : size1.width) === (size2 === null || size2 === void 0 ? void 0 : size2.width) && (size1 === null || size1 === void 0 ? void 0 : size1.height) === (size2 === null || size2 === void 0 ? void 0 : size2.height);
}

export { useScrollSize };
